import React from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import montaje from '../../recursos/Montaje-2-POS.png';
import montPos from '../../recursos/Montaje-POS.png';
import '../../../src/App.css';

const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
};

const fadeLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0 },
};

const fadeRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 },
};

const POSEmpatica = () => {
    const ref = React.useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-100px' });

    return (
        <section id="empaticapos" ref={ref} className="pos-section overflow-x-hidden">
            <div className="pos-container">
                <AnimatePresence>
                    {isInView && (
                        <>
                            <motion.h1
                                className="pos-title"
                                variants={fadeUp}
                                initial="hidden"
                                animate="visible"
                                transition={{ duration: 0.7 }}
                            >
                                Punto de venta (POS-Empatica)
                            </motion.h1>

                            <div className="pos-content">
                                <motion.div
                                    className="pos-images flex flex-col md:flex-row items-center gap-4"
                                    variants={fadeUp}
                                    initial="hidden"
                                    animate="visible"
                                    transition={{ duration: 0.6, delay: 0.3 }}>
                                    <motion.img
                                        src={montaje}
                                        alt="POS en celular"
                                        className="pos-main-img"
                                        variants={fadeLeft}
                                        initial="hidden"
                                        animate="visible"
                                        transition={{ duration: 0.7, delay: 0.4 }}
                                    />
                                    <motion.img
                                        src={montPos}
                                        alt="POS en tablet"
                                        className="pos-secondary-img"
                                        variants={fadeRight}
                                        initial="hidden"
                                        animate="visible"
                                        transition={{ duration: 0.7, delay: 0.6 }}
                                    />
                                </motion.div>

                                <motion.div
                                    className="pos-text"
                                    variants={fadeUp}
                                    initial="hidden"
                                    animate="visible"
                                    transition={{ duration: 0.7, delay: 0.8 }}
                                >
                                    <p>
                                        El <strong style={{ color: '#007bff' }}>POS Empatica</strong> es una solución práctica, ágil y completamente adaptable que permite a los negocios <strong style={{ color: '#007bff' }}>llevar el control de sus ventas, inventario y operaciones</strong> desde un smartphone o tablet sin necesidad de equipos voluminosos. Diseñado para pequeñas, medianas y grandes <strong>empresas que requieren movilidad y eficiencia,</strong> este sistema combina funcionalidad con facilidad de uso, permitiendo operar desde cualquier lugar con conexión a internet.
                                    </p>
                                    <p>
                                        Una de sus mayores fortalezas es su <strong style={{ color: '#007bff' }}>compatibilidad con el Quickpaymini,</strong> lo que permite vincular las funciones móviles con un sistema físico de autocobro, ampliando las capacidades del negocio al conectar el punto de venta portátil con una terminal segura y automatizada para el manejo de efectivo y pagos electrónicos.
                                    </p>

                                    {/* Botón de API agregado aquí */}
                                    <button
                                        className="bg-gradient-to-l from-[#2D4E86] to-[#29ABE2] text-white py-3 px-8 rounded-full text-lg font-medium hover:opacity-90 transition-opacity shadow-xl w-48"
                                        onClick={() => window.open("https://quickpay.empatica.mx/#productos", "_blank")}
                                    >
                                        Conoce más
                                    </button>
                                </motion.div>
                            </div>

                            <motion.div
                                className="pos-icons flex flex-wrap gap-28 mt-4 mb-4"
                                initial="hidden"
                                animate="visible"
                                variants={{
                                    visible: {
                                        transition: {
                                            staggerChildren: 0.2,
                                        },
                                    },
                                }}
                            >
                                {[
                                    { icon: '/Movilidad-icon.png', label: 'Movilidad total' },
                                    {
                                        icon: '/Integracion-icon.png',
                                        label: 'Integración Inteligente Con Quickpaymini',
                                    },
                                    {
                                        icon: '/Interfaz-icon.png',
                                        label: 'Interfaz Intuitiva y Rápida',
                                    },
                                ].map((item, index) => (
                                    <motion.div
                                        key={index}
                                        className="pos-icon-card"
                                        variants={fadeUp}
                                        transition={{ duration: 0.6 }}
                                    >
                                        <img
                                            src={item.icon}
                                            alt={`Icon ${index + 1}`}
                                            className="pos-icon-img"
                                        />
                                        <span className="pos-icon-label">{item.label}</span>
                                    </motion.div>
                                ))}
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>
            </div>
        </section>
    );
};

export default POSEmpatica;